import e from"styled-components";import{COLORS as t}from"../../constants/Theme.js";const o=e.div`
	display: flex;
	align-items: center;
	padding: ${e=>e.openDefault?"12px 16px":"12px 16px 0px 16px"};
	background-color: ${t.surface.subdued};
	justify-content: space-between;
	border-top-right-radius: 8px;
	border-top-left-radius: 8px;
`,r=e.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	background-color: ${t.surface.subdued};
	border-bottom: 1px solid ${t.stroke.primary};
`,i=e.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 32px;
	background-color: ${t.background.base};
`,p=e.div`
	margin: 8px;
	display: flex;
	flex-direction: column;
	gap: 4px;
	height: ${e=>e.height};
	overflow: scroll;
	&::-webkit-scrollbar-thumb {
		background-color: #e0e0e0 !important;
		border-radius: 8px;
	}
	&::-webkit-scrollbar {
		height: 5px;
		display: block;
		width: 8px;
	}
	&::-webkit-scrollbar-thumb:horizontal {
		width: 8px;
	}
`;export{i as BackHeader,p as Container,o as HeaderWrapper,r as RecommendWrapper};
